import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { API_URL } from '../config';
import CompanyCertificate from './CompanyCertificate';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_URL}api/contact/store`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.status === 'success') {
        Swal.fire({
          title: "Message Sent!",
          text: "Your message has been sent successfully!",
          icon: "success",
          confirmButtonColor: "#28a745",
          confirmButtonText: "OK"
        });

        setFormData({ name: '', email: '', contact: '', subject: '', message: '' });
      } else {
        Swal.fire({
          title: "Error!",
          text: "There was an error sending your message. Please try again.",
          icon: "error",
          confirmButtonColor: "#dc3545",
          confirmButtonText: "OK"
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Unable to connect to the server. Please check your internet connection.",
        icon: "error",
        confirmButtonColor: "#dc3545",
        confirmButtonText: "OK"
      });
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="container py-5">
          <div className="bg-light rounded p-5">
            <div className="row g-4">
              {/* Contact Form Section */}
              <div className="col-12 mb-4">
                <h2 className="mb-4">Contact Us</h2>
                <h4 className="mb-4">हमसे संपर्क करना बहुत आसान है! यदि आपके पास कोई प्रश्न, सुझाव या प्रतिक्रिया है, तो कृपया हमसे बेझिझक संपर्क करें।</h4>
                <form onSubmit={handleSubmit} className="mb-4">
                  <div className="row g-4">
                    <div className="col-lg-6 col-12">
                      <input
                        type="text"
                        className="w-100 form-control border-0 py-3"
                        name="name"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <input
                        type="email"
                        className="w-100 form-control border-0 py-3"
                        name="email"
                        placeholder="Enter Your Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <input
                        type="text"
                        className="w-100 form-control border-0 py-3"
                        name="contact"
                        placeholder="Enter Your Phone"
                        value={formData.contact}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <input
                        type="text"
                        className="w-100 form-control border-0 py-3"
                        name="subject"
                        placeholder="Subject"
                        value={formData.subject}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12">
                      <textarea
                        className="w-100 form-control border-0"
                        rows="6"
                        name="message"
                        placeholder="Your Message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12">
                      <button className="w-100 btn btn-primary py-3" type="submit">Submit Now</button>
                    </div>
                  </div>
                </form>
              </div>

              {/* Address and Other Details Section */}
              <div className="col-12 mb-4">
                <h4>Our Addresses</h4>
                <div className="row g-4">
                  <div className="col-xl-6 col-12">
                    <div className="d-flex p-4 rounded bg-white">
                      <i className="fas fa-map-marker-alt fa-2x text-primary me-4"></i>
                      <div>
                        <h4>Address 1</h4>
                        <p className="mb-0">F-32, Adarsh Marg, Sarvodaya Nagar, Lucknow-226016,U.P</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 col-12">
                    <div className="d-flex p-4 rounded bg-white">
                      <i className="fas fa-map-marker-alt fa-2x text-primary me-4"></i>
                      <div>
                        <h4>Address 2</h4>
                        <p className="mb-0">B-4/91, Vineet Khand, Gomti Nagar, Lucknow-226010,U.P</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-12">
                    <div className="d-flex p-2 rounded bg-white">
                      <div>
                        <h4>Contact Number</h4>
                        <p className="mb-0">9792531351</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-5 col-12">
                    <div className="d-flex p-2 rounded bg-white">
                      <div>
                        <h4>Mail Us</h4>
                        <p className="mb-0">panchayatkhabarindia@gmail.com</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-12">
                    <div className="d-flex p-2 rounded bg-white">
                      <div>
                        <h4>Share</h4>
                        <div className="d-flex">
                          <a href="https://www.facebook.com/profile.php?id=100082809802675" className="me-2" target="_blank">
                            <i style={{ color: '#1877F2' }} className="fab fa-facebook"></i>
                          </a>
                          <a href="https://x.com/KhabarPanchayat" className="me-2" target="_blank">
                            <i style={{ color: 'black' }} className="fas fa-times"></i>
                          </a>
                          <a href="https://www.instagram.com/panchayat_khabar/?hl=en" className="me-2" target="_blank">
                            <i className="fab fa-instagram"></i>
                          </a>
                          <a href="https://www.youtube.com/@PANCHAYAT_KHABAR" className="me-2" target="_blank">
                            <i className="fab fa-youtube" style={{ color: 'red' }}></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Map Section */}
              <div className="col-12">
                <div className="rounded position-relative">
                  <iframe
                    className="rounded w-100"
                    style={{ height: '400px' }}
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4462.874584370647!2d80.9704094!3d26.8795719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjbCsDUyJzQ2LjUiTiA4MMKwNTgnMjIuNyJF!5e0!3m2!1sen!2s!4v1694259649153!5m2!1sen!2s"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                  {/* Open Map Button */}
                  <button
                    className="btn btn-primary position-absolute"
                    style={{
                      top: '10px',
                      right: '60px',
                      zIndex: 10,
                      background: '#007bff',
                      border: 'none',
                      padding: '5px 10px',
                      borderRadius: '50%',
                      cursor: 'pointer',
                    }}
                    onClick={() => window.open('https://www.google.com/maps/search/?api=1&query=26.8795719,80.9704094', '_blank')}
                    title="Open in Google Maps"
                  >
                    <i className="fa fa-map-marker" style={{ fontSize: '20px', color: 'white' }}></i>
                  </button>
                  {/* Share Location Button */}
                  <button
                    className="btn btn-secondary position-absolute"
                    style={{
                      top: '10px',
                      right: '10px',
                      zIndex: 10,
                      background: '#6c757d',
                      border: 'none',
                      padding: '5px 10px',
                      borderRadius: '50%',
                      cursor: 'pointer',
                    }}
                    onClick={() =>
                      window.open('https://www.google.com/maps/search/?api=1&query=26.8795719,80.9704094', '_blank')
                    }
                  >
                    <i className="fa fa-share-alt" style={{ fontSize: '20px', color: 'white' }}></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
          <CompanyCertificate />
        </div>
      </div>
    </>
  );
};

export default Contact;
